import React from 'react'
import {FondosContactoItem} from './FondosContactoItem'

function FondosContacto(props) {
  const displayItems = (props) => {
    const fondos = props.fondos

    if (fondos.length > 0) {
      return fondos.map((fondo, index) => {
        return (
          <FondosContactoItem
            key={index}
            fondo={fondo}
            setFondosContacto={props.setFondosContacto}
          />
        )
      })
    } else {
      return <h3>No hay marcas</h3>
    }
  }

  return <>{displayItems(props)}</>
}

export {FondosContacto}
